// extracted by mini-css-extract-plugin
export default {"label":"CEeUZD","title":"VnvkL5","icon":"rGW_Kb","iconButton":"k7a7PL"};